import { useCallback, useEffect } from 'react';
import { getWindow } from 'utilities/window.js';

/**
 * Window CB that closeAd function calls in the advertising template
 * Adds when mounted
 * Removes when unmounted
 **/
export const WindowHideInterstitialCB = ({ setDisplayModal }: { setDisplayModal: (b: boolean) => void }): void => {
  const removeWindowHideInterstitialCB = useCallback(() => {
    const lclWindow = getWindow();
    if (lclWindow) {
      lclWindow.MetService.hideInterstitial = undefined;
    }
  }, []);

  const addWindowHideInterstitialCB = useCallback(() => {
    const lclWindow = getWindow();
    if (lclWindow) {
      /** This is a global that is called within the add template (see template.html) */
      lclWindow.MetService.hideInterstitial = () => {
        setDisplayModal(false);
      };
    }
    // We dont need the setDisplayModal here as it is a callback from useState
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Add window interstitial callback when mounted remove when unmounted */
  useEffect(() => {
    addWindowHideInterstitialCB();
    return () => removeWindowHideInterstitialCB();
  }, [removeWindowHideInterstitialCB, addWindowHideInterstitialCB]);
};
